import React, { useMemo } from 'react'
import { defineMessages, FormattedMessage, MessageDescriptor } from 'react-intl'

import { ClientFiltersCheckboxSection } from './ClientFiltersCheckboxSection'

export enum SessionType {
  INTAKE = 'INTAKE',
  FOLLOW_UP = 'FOLLOW_UP',
}

export type ClientFiltersSessionTypeSectionProps = {
  values: SessionType[]
  onChange: (values: SessionType[]) => void
}

export const ClientFiltersSessionTypeSection: React.FC<ClientFiltersSessionTypeSectionProps> = ({
  values,
  onChange,
}) => {
  const filterNames: Record<SessionType, MessageDescriptor> = useMemo(
    () =>
      defineMessages({
        [SessionType.INTAKE]: {
          defaultMessage: 'Intake',
          description: 'Label for filtering conversations by intake session',
        },
        [SessionType.FOLLOW_UP]: {
          defaultMessage: 'Follow up',
          description: 'Label for filtering conversations by follow up session',
        },
      }),
    [],
  )

  return (
    <ClientFiltersCheckboxSection
      title={<FormattedMessage defaultMessage='Session type' description='Session type filter section' />}
      items={Object.values(SessionType).map((value) => ({
        id: value,
        text: <FormattedMessage {...filterNames[value]} />,
      }))}
      values={values}
      onChange={onChange}
      name='sessionType'
    />
  )
}
